import { Theme } from "@/shared/themes/Theme.interface";
//import { isColorDark } from "@/shared/utils/helpers";

const DEFAULT_FONT_FALLBACK = "Inter";

export type ThemeToToolProjectStylesMappers =
    | typeof mapThemeToCoffeeColors
    | typeof mapThemeToCookieColors
    | typeof mapThemeToFaqColors
    | typeof mapThemeToLegalColors
    | typeof mapThemeToLoveColors
    | typeof mapThemeToPageColors
    | typeof mapThemeToPlayerColors
    | typeof mapThemeToPricingColors
    | typeof mapThemeToTickerColors
    | typeof mapThemeToTimerColors;

export function mapThemeToCoffeeColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        mainColor: colors.brand,
        backColor: colors.background,
        textColor: colors.text,
        borderColor: colors.border,
        buttonTextColor: colors.background,
    };
}

export function mapThemeToCookieColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        buttonColor: colors.brand,
        backColor: colors.background,
        textColor: colors.text,
    };
}

export function mapThemeToFaqColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        faqColor: colors.background,
        titleColor: colors.text,
        backColor: colors.cardBackground,
        questionColor: colors.cardText,
        borderColor: colors.border,
    };
}

export function mapThemeToLegalColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        mainColor: colors.brand,
        background: colors.background,
        fontColor: colors.text,
        borderColor: colors.border,
    };
}

export function mapThemeToLoveColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        // highlightColor: colors.brand,
        wallColor: colors.background,
        titleColor: colors.text,
        backColor: colors.cardBackground,
        textColor: colors.cardText,
        borderColor: colors.border,
    };
}

export function mapThemeToPageColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        colors: { ...colors },
    };
}

export function mapThemeToPlayerColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        mainColor: colors.brand,
        backColor: colors.background,
        headerColor: colors.background,
        textColor: colors.text,
        headingColor: colors.text,
        borderColor: colors.border,
    };
}

export function mapThemeToPricingColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        highlightColor: colors.brand,
        pricingColor: colors.background,
        titleColor: colors.text,
        backColor: colors.cardBackground,
        headingsColor: colors.cardText,
        borderColor: colors.border,
    };
}

export function mapThemeToTickerColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        colors: { ...colors },
    };
}

export function mapThemeToTimerColors(theme: Theme) {
    const { id, colors = {}, font } = theme || {};
    return {
        theme: String(id),
        fontFamily: font || DEFAULT_FONT_FALLBACK,
        labelColor: colors.text,
        figColor: colors.text,
        backColor: colors.cardBackground,
    };
}
